import type { CSSProperties } from "react";
import { cx } from "../cx";

/**
 * Barra de progreso del sistema (`sk-progress`): una proporción que se lee
 * de un vistazo, con su nombre para el lector (`role=img` + `label`, como
 * las firmas de un cuaderno en biblioteca.html: «40 % firmadas»). `value`
 * va de 0 a 1 y se recorta a ese rango.
 */
export function Progress({ value, label, className, style }: { value: number; label: string; className?: string | undefined; style?: CSSProperties | undefined }) {
  const pct = Math.round(Math.min(1, Math.max(0, Number.isFinite(value) ? value : 0)) * 100);
  return (
    <div className={cx("sk-progress", className)} role="img" aria-label={label} style={style}>
      <div style={{ width: `${pct}%` }} />
    </div>
  );
}
